import { statusOptions } from '@/constants/ticket3/ticketConstant'
export default {
  methods: {
    ticketColorStatus(val) {
      const trimVal = val.trim().toLowerCase()
      const status = statusOptions.find((item) => item.value === trimVal)
      return status ? status.color : ''
    },
    ticketLabelStatus(val) {
      const trimVal = val.trim().toLowerCase()
      const status = statusOptions.find((item) => item.value === trimVal)
      return status ? status.label : ''
    },
    handleGetMoodEmoji(mood) {
      if (mood) {
        if (mood == 'positive') {
          return '😊'
        } else if (mood == 'negative') {
          return '😡'
        } else if (mood == 'neutral') {
          return '😐'
        }
      }
      return ''
    },
    formatTicketData(data) {
      const result = { ...data }
      if (data.assignadminid) {
        result.assign_admin_id = data.assignadminid
      }
      if (data.assigngroupid) {
        result.assign_group_id = data.assigngroupid
      }
      if (data.assignsubgroupid) {
        result.assign_sub_group_id = data.assignsubgroupid
      }

      return result
    },
    handleTicketToWrapUpRoute(data) {
      if (data.wrap_up) {
        const wrapUp = data.wrap_up.map((wrapUp) => {
          return {
            level: 0,
            title: wrapUp,
            type: 'wrapup'
          }
        })
        wrapUp.forEach((element, index) => {
          const wrapUpRoute = Object.entries(data.wrap_up_route[index])
          wrapUp[index] = [
            element,
            ...wrapUpRoute.map((el) => {
              return {
                level: el[0].split('_')[1],
                title: el[1],
                type: 'level'
              }
            })
          ]
        })
        return wrapUp
      }
      return []
    },
    handleFormatWrapUpRouteToSave(wrapUpRoute) {
      // wrapup to object by key is level_n and value is title
      // except level_0
      const result_wrap = {
        wrap_up: wrapUpRoute ? wrapUpRoute.map((wrapUp) => wrapUp[0].title, []) : [],
        wrap_up_route: wrapUpRoute
          ? wrapUpRoute.map((wrapUp) => {
              let result = {}
              wrapUp.forEach((element) => {
                if (element.level == 0) return
                result = {
                  ...result,
                  [`level_${element.level}`]: element.title
                }
              })
              return result
            }, [])
          : []
      }

      return result_wrap
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/ticketMixin.js